import { render, staticRenderFns } from "./po_ord.vue?vue&type=template&id=c741e63e&scoped=true"
import script from "./po_ord.vue?vue&type=script&lang=js"
export * from "./po_ord.vue?vue&type=script&lang=js"
import style0 from "./po_ord.vue?vue&type=style&index=0&id=c741e63e&prod&scoped=true&lang=less"
import style1 from "./po_ord.vue?vue&type=style&index=1&id=c741e63e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c741e63e",
  null
  
)

export default component.exports